import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";
import ViagemAprovacao from "./ViagemAprovacao";
import ViagemDespesa from "./ViagemDespesa";
import ViagemDespesaPrevista from "./ViagemDespesaPrevista";

export default class Viagem implements BaseModel {

    id: number;
    codigo: string | null;
    situacao: string;
    usuarioSolicitante: Usuario | null;
    dataSolicitacao: Date | null;
    centroCusto: CentroCusto | null;
    itinerario: string;
    motivoViagem: string;
    acompanhante: string;
    dataPartida: Date | null;
    dataRetorno: Date | null;
    tipoLocomocao: string;
    reservarPassagem: boolean;
    observacaoReservaPassagem: string;
    reservarHotel: boolean;
    observacaoReservaHotel: string;
    observacaoSolicitacao: string;
    custoPorQuilometro: number | null;
    previsaoQuilometros: number | null;
    valorAdiantamento: number;
    dataAdiantamento: Date | null;
    depositoConta: boolean;
    bancoDeposito: string;
    agenciaDeposito: string;
    contaDeposito: string;
    usuarioResponsavelAutorizacao: Usuario | null;
    dataAcerto: Date | null;
    aprovacoes: ViagemAprovacao[];
    despesas: ViagemDespesa[];
    despesasPrevistas: ViagemDespesaPrevista[];

    constructor(
        id = 0,
        codigo = null,
        situacao = 'ABERTA',
        usuarioSolicitante = null,
        dataSolicitacao = null,
        centroCusto = null,
        itinerario = '',
        motivoViagem = '',
        acompanhante = '',
        dataPartida = null,
        dataRetorno = null,
        tipoLocomocao = '',
        reservarPassagem = false,
        observacaoReservaPassagem = '',
        reservarHotel = false,
        observacaoReservaHotel = '',
        observacaoSolicitacao = '',
        custoPorQuilometro: number | null = null,
        previsaoQuilometros: number | null = null,
        valorAdiantamento = 0,
        dataAdiantamento = null,
        depositoConta = false,
        bancoDeposito = '',
        agenciaDeposito = '',
        contaDeposito = '',
        usuarioResponsavelAutorizacao = null,
        dataAcerto = null,
        aprovacoes: ViagemAprovacao[] = [],
        despesas: ViagemDespesa[] = [],
        despesasPrevistas: ViagemDespesaPrevista[] = [],
    ) {
        this.id = id;
        this.codigo = codigo;
        this.situacao = situacao;
        this.usuarioSolicitante = usuarioSolicitante;
        this.dataSolicitacao = dataSolicitacao;
        this.centroCusto = centroCusto;
        this.itinerario = itinerario;
        this.motivoViagem = motivoViagem;
        this.acompanhante = acompanhante;
        this.dataPartida = dataPartida;
        this.dataRetorno = dataRetorno;
        this.tipoLocomocao = tipoLocomocao;
        this.reservarPassagem = reservarPassagem;
        this.observacaoReservaPassagem = observacaoReservaPassagem;
        this.reservarHotel = reservarHotel;
        this.observacaoReservaHotel = observacaoReservaHotel;
        this.observacaoSolicitacao = observacaoSolicitacao;
        this.custoPorQuilometro = custoPorQuilometro;
        this.previsaoQuilometros = previsaoQuilometros;
        this.valorAdiantamento = valorAdiantamento;
        this.dataAdiantamento = dataAdiantamento;
        this.depositoConta = depositoConta;
        this.bancoDeposito = bancoDeposito;
        this.agenciaDeposito = agenciaDeposito;
        this.contaDeposito = contaDeposito;
        this.usuarioResponsavelAutorizacao = usuarioResponsavelAutorizacao;
        this.dataAcerto = dataAcerto;
        this.aprovacoes = aprovacoes;
        this.despesas = despesas;
        this.despesasPrevistas = despesasPrevistas;
    }

}
